import React from "react";
import { styles } from "./leadsStyles";

export function LeadsWebhookTab({ vm }) {
  const {
    webhookUrl,
    setWebhookUrl,
    webhookSecret,
    setWebhookSecret,
    webhookMessage,
    webhookStatus,
    saveWebhookConfig,
    testWebhook,
    removeWebhookConfig,
  } = vm;
  return (
              <div style={styles.webhookContainer}>
                <h3 style={styles.sectionTitle}>Integração com CRM</h3>
                <p style={styles.webhookDescription}>
                  Configure um webhook para enviar automaticamente seus leads para seu CRM ou outra ferramenta.
                </p>
                
                {webhookMessage && (
                  <div style={{
                    ...styles.message,
                    ...(webhookStatus === "success" ? styles.messageSuccess : styles.messageError)
                  }}>
                    {webhookMessage}
                  </div>
                )}
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>URL do Webhook:</label>
                  <input
                    type="text"
                    value={webhookUrl}
                    onChange={(e) => setWebhookUrl(e.target.value)}
                    placeholder="https://seu-crm.com/api/webhook"
                    style={styles.input}
                  />
                </div>
                
                <div style={styles.formGroup}>
                  <label style={styles.label}>Chave Secreta (opcional):</label>
                  <input
                    type="text"
                    value={webhookSecret}
                    onChange={(e) => setWebhookSecret(e.target.value)}
                    placeholder="Chave para autenticação (opcional)"
                    style={styles.input}
                  />
                </div>
                
                <div style={styles.buttonGroup}>
                  <button onClick={saveWebhookConfig} style={styles.button}>
                    Salvar Configuração
                  </button>
                  <button onClick={testWebhook} style={styles.buttonSecondary}>
                    Testar Webhook
                  </button>
                  <button onClick={removeWebhookConfig} style={styles.buttonDanger}>
                    Excluir integração
                  </button>
                </div>
              </div>
  );
}
